it("should parse sparse arrays", function() { // issue #136
	[,null].should.have.length(2);
	[0,,,0].should.have.length(4);
});



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/javascript/index.js
 ** module id = 0
 ** module chunks = 0
 **/